module.exports = "<div class=q-marg-all-xl> <div class=discrepancies-delete-body> Deleted record cannot be updated </div> <div class=\"q-marg-top-xl delete-error\" style=display:none> <div class=\"q-alert q-alert-red\"> Error deleting record </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/receivingDiscrepancies/html/deleteDiscrepancyModalBody.html
// module id = 1390
// module chunks = 1